import styled from 'styled-components';
import { mixins } from '@sy/component-library';

const { media } = mixins;

export const InfoCardWrapper = styled.div`
	width: 100%;
	padding: 96px 0 144px 0;
	background-color: ${({ theme }) => theme.colors.primary.extraLight};
`;

export const InfoCardContent = styled.div`
	width: 100%;
	max-width: 1224px;
	margin: 0 auto;
	display: flex;
	padding: 60px;
	flex-direction: row;
	gap: 80px;
	background-color: ${({ theme }) => theme.colors.white};
	box-shadow: ${({ theme }) => theme.shadows.subtle};
	border-radius: 16px;

	${media.belowLarge`
		flex-direction: column;
		gap: 24px;
		padding: 24px;
	`}
`;

export const Title = styled.h1`
	font-weight: 700;
	font-size: 1.8rem;
	line-height: 2.7rem;
	text-transform: uppercase;
	margin: 0;
`;

export const DescriptionWrapper = styled.div`
	font-size: 1.8rem;
	line-height: 2.7rem;
	white-space: pre-line;
`;

export const TitlesColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	justify-content: space-between;
	flex: 1.5;
`;

export const HighlightsColumn = styled.div`
	display: flex;
	flex-direction: column;
	gap: 24px;
	justify-content: space-between;
	flex: 2.5;
`;

export const HighlightWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: flex-start;
	padding: 32px 48px;
	gap: 12px;
	background-color: ${({ theme }) => theme.colors.grey[100]};
	border-radius: 16px;
`;

export const TextImageWrapper = styled.div`
	position: relative;
	min-width: 24px;
	min-height: 24px;
`;

export const Highlight = styled.span`
	font-weight: 600;
	font-size: 1.6rem;
	line-height: 150%;
	color: ${({ theme }) => theme.colors.grey[900]};
`;

export const TitleAndDescriptionWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 12px;
	color: #131315;
`;

export const StyledListItem = styled.li`
	font-size: 1.8rem;
	line-height: 3.8rem;
`;

export const StyledUnorderedList = styled.ul`
	margin: 0;
	padding-inline-start: 16px;
	display: flex;
	flex-direction: column;
`;

export const StyledParagraph = styled.p`
	margin: 0;
`;
